"use strict";

import Circle from "ol/geom/Circle";
import {fromCircle} from "ol/geom/Polygon";

/**
 * @classdesc
 * Wrapperklasse für eine OpenLayers Kreis-Geometrie.
 *
 * @class
 * @extends gc.gis.geom.GCCircle
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {ol.geom.Circle} opt_circle gewrappte Kreis-Geometrie-Instanz
 */
gc.gis.geom.OLCircle = function(opt_circle)
{
    if (!opt_circle)
    {
        opt_circle = new Circle([]);
    }

    gc.gis.assert.isInstance(opt_circle, Circle);
    gc.gis.geom.GCCircle.call(this, opt_circle);

    // mixin erstellen
    const source = gc.gis.geom.OLGeometry.prototype;
    for (let prop in source) {
        if (source.hasOwnProperty(prop)) {
            this[prop] = source[prop];
        }
    }
};
gc.gis.geom.OLCircle.prototype = Object.create(gc.gis.geom.GCCircle.prototype);

/**
 * @inheritDoc
 */
gc.gis.geom.OLCircle.prototype.toPolygon = function()
{
    const poly = new gc.gis.geom.OLPolygon(fromCircle(this.getImpl(), 64, 0));
    poly.setCRS(this.getCRS());

    return poly;
};